import { t } from '../i18n'

export function initDashboardSettings() {
    const container = document.getElementById('summoner-section');
    if (!container) return;

    const config = window.dashboardSettingsConfig || {};
    const { scanUrl, setDefaultUrl, updateSettingsUrl, csrfToken } = config;

    if (!scanUrl || !csrfToken) {
        console.warn('Dashboard settings config missing');
        return;
    }

    initSocialSettings(updateSettingsUrl, csrfToken);
    initRegionScanner(scanUrl, setDefaultUrl, csrfToken);
}

function initSocialSettings(updateSettingsUrl, csrfToken) {
    document.querySelectorAll('.dash-social-ok').forEach(btn => {
        btn.addEventListener('click', async function() {
            const field = this.dataset.field;
            const input = document.querySelector(`.dash-social-input[data-field="${field}"]`);
            const value = input.value;

            this.disabled = true;
            this.textContent = '...';

            try {
                const response = await fetch(updateSettingsUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': csrfToken,
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({ [field]: value })
                });

                if (response.ok) {
                    this.textContent = '✓';
                    this.classList.add('success');
                    window.Toast?.success(t('Сохранено'));
                    setTimeout(() => { this.classList.remove('success'); }, 1500);
                } else {
                    showSaveError(this);
                }
            } catch (error) {
                showSaveError(this);
            }

            this.disabled = false;
        });
    });
}

function showSaveError(btn) {
    btn.textContent = '✗';
    btn.classList.add('error');
    window.Toast?.error(t('Ошибка сохранения'));
    setTimeout(() => {
        btn.textContent = '✓';
        btn.classList.remove('error');
    }, 1500);
}

function initRegionScanner(scanUrl, setDefaultUrl, csrfToken) {
    const scanTrigger = document.getElementById('scan-trigger');
    const scanProgress = document.getElementById('scan-progress');
    const scanRegions = document.getElementById('scan-regions');
    const scanResults = document.getElementById('scan-results');
    const resultsList = document.getElementById('results-list');
    const resultsTitle = document.getElementById('results-title');
    const scanLast = document.getElementById('scan-last');

    const mainName = document.getElementById('main-name');
    const mainRank = document.getElementById('main-rank');
    const mainRegion = document.getElementById('main-region');
    const mainLevel = document.getElementById('main-level');
    const mainAvatarImg = document.getElementById('main-avatar-img');
    const mainAvatar = document.getElementById('main-avatar');

    let eventSource = null;
    let foundSummoners = [];
    let scannedCount = 0;

    function startScan() {
        foundSummoners = [];
        scannedCount = 0;

        scanResults.classList.add('hidden');
        scanProgress.classList.remove('hidden');
        scanTrigger.classList.add('hidden');
        scanRegions.innerHTML = '';

        eventSource = new EventSource(scanUrl);

        eventSource.onmessage = function(event) {
            const data = JSON.parse(event.data);

            if (data.done) {
                eventSource.close();
                finishScan();
                return;
            }

            scannedCount++;

            const tag = document.createElement('span');
            tag.className = 'dash-region-tag checking';
            tag.textContent = data.region.slug.toUpperCase();
            scanRegions.appendChild(tag);

            setTimeout(() => {
                if (data.found) {
                    tag.className = 'dash-region-tag found';
                    tag.textContent = data.region.slug.toUpperCase() + ' ✓';

                    foundSummoners.push({
                        id: data.summoner.id,
                        name: data.summoner.name,
                        tag: data.summoner.tag,
                        level: data.summoner.level,
                        icon: data.summoner.icon,
                        is_main: data.summoner.is_main,
                        rank: data.summoner.rank,
                        region: data.region
                    });
                } else {
                    tag.className = 'dash-region-tag not-found';
                }
            }, 150);
        };

        eventSource.onerror = function() {
            eventSource.close();
            finishScan();
        };
    }

    function stopScan() {
        if (eventSource) {
            eventSource.close();
        }
        finishScan();
    }

    function finishScan() {
        scanProgress.classList.add('hidden');
        scanTrigger.classList.remove('hidden');

        if (scanLast) {
            scanLast.textContent = t('Последнее') + ': ' + t('только что');
        }

        if (foundSummoners.length === 0) {
            return;
        }

        scanResults.classList.remove('hidden');
        resultsTitle.textContent = t('Найдено') + ' ' + foundSummoners.length + ' ' + t('из') + ' ' + scannedCount + ' ' + t('регионов');

        renderResults();
    }

    function renderResults() {
        resultsList.innerHTML = '';

        foundSummoners.forEach(summoner => {
            const isActive = summoner.is_main;
            const item = document.createElement('div');
            item.className = 'dash-sr-item' + (isActive ? ' active' : '');
            const rankHtml = `<span class="dash-sr-rank">${summoner.rank?.display_text || ''}</span>`;

            item.innerHTML = `
                <div class="dash-sr-avatar">
                    <img src="/images/league/summoners/${summoner.icon}.webp" alt="">
                    <span class="dash-sr-level">${summoner.level}</span>
                </div>
                <div class="dash-sr-info">
                    <div class="dash-sr-name">${summoner.name}#${summoner.tag}</div>
                    <div class="dash-sr-meta">
                        <span class="region-badge">${summoner.region.slug.toUpperCase()}</span>
                        ${rankHtml}
                    </div>
                </div>
                ${isActive
                    ? `<span class="dash-sr-badge current">✓ ${t('Активный')}</span>`
                    : `<button type="button" class="dash-sr-badge select" data-id="${summoner.id}">${t('Использовать')}</button>`
                }
            `;
            resultsList.appendChild(item);
        });

        resultsList.querySelectorAll('.dash-sr-badge.select').forEach(btn => {
            btn.addEventListener('click', function() {
                selectProfile(parseInt(this.dataset.id));
            });
        });
    }

    async function selectProfile(summonerId) {
        const summoner = foundSummoners.find(s => s.id === summonerId);
        if (!summoner) return;

        try {
            const response = await fetch(setDefaultUrl, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken
                },
                body: JSON.stringify({ summoner_id: summonerId })
            });

            if (response.ok) {
                foundSummoners.forEach(s => s.is_main = (s.id === summonerId));

                mainName.textContent = summoner.name + '#' + summoner.tag;
                mainRank.textContent = summoner.rank?.display_text || '';
                mainRegion.textContent = summoner.region.slug.toUpperCase();
                mainRegion.classList.remove('hidden');

                if (mainLevel) {
                    mainLevel.textContent = summoner.level;
                }

                if (mainAvatarImg) {
                    mainAvatarImg.src = '/images/league/summoners/' + summoner.icon + '.webp';
                } else {
                    mainAvatar.innerHTML = `
                        <img src="/images/league/summoners/${summoner.icon}.webp" alt="" id="main-avatar-img">
                        <span class="dash-sum-level" id="main-level">${summoner.level}</span>
                    `;
                }

                renderResults();

                window.Toast?.success(t('Профиль обновлён'));
            }
        } catch (error) {
            console.error('Failed to set default:', error);
            window.Toast?.error(t('Ошибка сохранения'));
        }
    }

    scanTrigger?.addEventListener('click', startScan);
    document.getElementById('btn-stop')?.addEventListener('click', stopScan);
    document.getElementById('btn-rescan')?.addEventListener('click', startScan);
}
